import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  checkAccess,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { CorebaseURL, corefetch, corepost } from "../../Util/axios_core_helper";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { KendoEditor } from "../../Kendo/kendo_editor";

export const FAQ = () => {
  const [editVisible, setEditVisible] = useState(false);
  const [error, setError] = useState({});
  const [refreshGrid, setrefreshGrid] = useState(0);
  const modalRef = useRef(null);
  const [FAQList, setFAQList] = useState([]);
  const [QDup, setQDup] = useState(false);
  const [Loading, setLoading] = useState(false);

  const [Faq, SetFaq] = useState({
    faqId: 0,
    question: "",
    answer: "",
    sortOder: 0,
    savedBy: 0,
  });

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    SetFaq({
      faqId: 0,
      question: "",
      answer: "",
      sortOrder: 0,
      savedBy: 0,
    });
    setEditVisible(false);
    setError({});
    $("#faq-cancel").click();
    setQDup(false);
    setQDup(false);
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const err = ValidateForm(e);
    if (err) {
      setError(err);
    } else if (!QDup) {
      setLoading(true);
      let data = {
        faqId: Faq.faqId,
        question: Faq.question,
        answer: Faq.answer,
        savedBy: Faq.savedBy,
      };

      await corepost("Faq/InsertUpdateFaq", data);
      setrefreshGrid(refreshGrid + 1);
      fetchData();
      clearForm();
    }
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const handleEditClick = async (e) => {
    let temp = Faq;

    Faq.faqId = e.faqID;
    Faq.question = e.question;
    Faq.answer = e.answer;
    SetFaq(temp);
    setEditVisible(true);

    const modal = new bootstrap.Modal(document.getElementById("add_faq"));
    modal.show();
  };
  const fetchData = async () => {
    try {
      const list = await corefetch("Faq/GetFaq");
      setFAQList(list);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
    // Prevent Bootstrap modal from stealing focus from Kendo popups
    document.addEventListener("focusin", function (e) {
      const editorPopup = document.querySelector(".k-popup");
      const modal = document.querySelector(".modal.show");

      if (
        modal &&
        editorPopup &&
        !modal.contains(e.target) &&
        editorPopup.contains(e.target)
      ) {
        e.stopPropagation();
      }
    });
  }, []);
  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `Faq/DeleteFaq?id=${e.faqID}&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        fetchData();
        setrefreshGrid(refreshGrid + 1);
      });
    };
    confirmDelete(onDelete);
  };
  const [refreshflag, setrefreshflag] = useState(0);

  const onRowReorderChange = async (List) => {
    try {
      let FaqID = $(List.newRow).find("td").eq(0).text();
      let oldSortId = $(List.newRow).find("td").eq(1).text();
      let newSortId = $(List.oldRow).find("td").eq(1).text();
      await corefetch(
        `Faq/SortFaq?TypeId=${FaqID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
      );
      setrefreshGrid(refreshGrid + 1);
    } catch (error) {
      console.error("Error during row reorder:", error);
    }
  };

  const handleEditorChange = (e) => {
    const newValue = e;

    // Strip HTML tags and extra spaces
    const strippedValue = newValue
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    const isEmpty = /^[\s\n]*$/.test(strippedValue);

    SetFaq((prev) => ({
      ...prev,
      answer: newValue,
    }));
    onValidation("answer", newValue);
  };
  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">FAQ</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Configuration</a>
              </li>
              <li className="breadcrumb-item active">FAQ</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#add_faq"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
            </div>

            <div>
              <i>
                <span style={{ backgroundColor: "yellow" }}>Note:</span>
                This module supports drag-and-drop functionality, you can easily
                rearrange or move data as needed.
              </i>
              <KendoGrid
                name={"welcomeTo-config"}
                url={CorebaseURL + "Faq/GetFaq"}
                schema={{}}
                columns={[
                  {
                    field: "faqID",
                    filterable: false,
                    hidden: true,
                  },
                  {
                    field: "sortOrder", // Add this column if it's missing.
                    hidden: true,
                  },
                  {
                    field: "question",
                    title: "Questions",
                  },

                  {
                    field: "answer",
                    title: "Answers",
                    template: function (e) {
                      const maxLength = 50;

                      const stripHtmlTags = (input) => {
                        const tempDiv = document.createElement("div");
                        tempDiv.innerHTML = input || "";
                        return tempDiv.textContent || tempDiv.innerText || "";
                      };

                      const plainTextDescription = stripHtmlTags(e.answer);

                      const truncatedDescription =
                        plainTextDescription.length > maxLength
                          ? `${plainTextDescription.substring(0, maxLength)}...`
                          : plainTextDescription;

                      return `<div>${truncatedDescription}</div>`;
                    },
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                onEditClick={(e) => handleEditClick(e)}
                onDeleteClick={(e) => handleDeleteClick(e)}
                refreshWhen={refreshGrid}
                disableExportExcel={true}
                enableRowReorderable={true}
                onRowReorder={onRowReorderChange}
                // refreshWhen={refreshflag}
                height={"60vh"}
              />
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Add faq Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_faq"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered blog"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="faqform" onSubmit={onSubmit}>
                <input type="hidden" name="TypeId" value={Faq.faqId} />
                <div className="row">
                  <div className="col-md-12">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Question <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Question with a maximum length of 200 characters." />
                      </label>
                      <textarea
                        name="Question"
                        maxLength={200}
                        className="form-control"
                        data-required="true"
                        value={Faq.question}
                        placeholder="Question"
                        onChange={(e) => {
                          SetFaq((prev) => ({
                            ...prev,
                            question: e.target.value,
                          }));
                          onValidation("Question", e.target.value);
                          let dup;
                          if (Faq.faqId > 0) {
                            const matchingItem = FAQList.find(
                              (item) =>
                                item.question.trim().toLowerCase() ==
                                  e.target.value.trim().toLowerCase() &&
                                item.faqID != Faq.faqId
                            );

                            dup = matchingItem;
                            setQDup(dup);
                          } else {
                            const matchingItem = FAQList.find(
                              (item) =>
                                item.question.trim().toLowerCase() ==
                                e.target.value.trim().toLowerCase()
                            );
                            dup = matchingItem;
                            setQDup(dup);
                          }
                        }}
                      />
                      {error.Question && (
                        <ErrorMsg text="Question is required" />
                      )}
                      {QDup && <ErrorMsg text="Question is already exist" />}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Answer <span className="text-danger">*</span>
                        {/* <InfoIcon content="Please provide a Answer with a maximum length of 500 characters." /> */}
                      </label>
                      {/* <textarea
                        name="answer"
                        maxLength={500}
                        placeholder="Answer"
                        className="form-control"
                        value={Faq.answer}
                        data-required="true"
                        onChange={(e) => {
                          SetFaq((prev) => ({
                            ...prev,
                            answer: e.target.value,
                          }));
                          onValidation("answer", e.target.value);
                        }}
                      /> */}

                      <KendoEditor
                        name="answer"
                        required={true}
                        value={Faq.answer}
                        onChange={handleEditorChange}
                        insertImage={false}
                        createLink={false}
                        unlink={false}
                        onValidate={onValidation}
                      />
                      {error.answer && <ErrorMsg text="Answer is required" />}
                    </div>
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="faq-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add faq Modal --> */}
    </>
  );
};
